import { flexRender, Table, Header, Column } from "@tanstack/react-table"
import { OverlayTrigger, Popover } from "react-bootstrap"
import { Filters } from "./Filters"
interface HeadProps<T extends object> {
    table: Table<T>
    searchPlaceholder?: string
}

/**
 * El header té moltes responsabilitats a l'hora de processar les dades, és el que gestionara el sorting i els filtres
 */
function Head<T extends object>({ table, searchPlaceholder }: HeadProps<T>) {
    return (
        <thead>
            {table.getHeaderGroups().map((headerGroup) => (
                <tr key={headerGroup.id}>
                    {headerGroup.headers.map((header) => (
                        <TableHeaderCell key={header.id} header={header} manual={table.options.manualFiltering} searchPlaceholder={searchPlaceholder} />
                    ))}
                </tr>
            ))}
        </thead>
    )
}

export default Head

function SortIcon({ isSorted }: { isSorted: false | "asc" | "desc" }) {
    if (isSorted === "asc") return <i className='bi bi-arrow-up' />
    if (isSorted === "desc") return <i className='bi bi-arrow-down' />
    return <i className='bi bi-arrow-down unsorted' />
}

function TableHeaderCell<T extends object>({ header, manual = false, searchPlaceholder }: { header: Header<T, unknown>; manual?: boolean, searchPlaceholder?: string }) {
    const canSort = header.column.getCanSort()
    const isSorted = header.column.getIsSorted()
    const canFilter = header.column.getCanFilter()
    return (
        <th key={header.id} className={`table-header`}>
            <div className='d-flex'>
                {canFilter && <FilterPopover column={header.column} manual={manual} searchPlaceholder={searchPlaceholder}/>}
                <div onClick={canSort ? header.column.getToggleSortingHandler() : undefined} className={canSort ? "clickable" : ""}>
                    {!header.isPlaceholder && flexRender(header.column.columnDef.header, header.getContext())}
                    {canSort && <SortIcon isSorted={isSorted} />}
                </div>
            </div>
        </th>
    )
}

function FilterPopover<T extends object>({ column, manual = false, searchPlaceholder }: { column: Column<T, unknown>; manual?: boolean, searchPlaceholder?: string }) {
    const hasFilters = column.getFilterValue()

    return (
        <OverlayTrigger
            trigger='click'
            placement='auto'
            rootClose
            popperConfig={{
                modifiers: [
                    {
                        name: "flip",
                        options: {
                            allowedAutoPlacements: ["left", "top", "bottom"]
                        }
                    }
                ]
            }}
            overlay={
                <Popover>
                    <Popover.Body>
                        <Filters column={column} manual={manual} searchPlaceholder={searchPlaceholder} />
                    </Popover.Body>
                </Popover>
            }
        >
            <i className={`bi bi-filter ${hasFilters ? "active" : ""}`} />
        </OverlayTrigger>
    )
}
